// extracted by css-extract-rspack-plugin
export default {"switch":"switch-qCpYar","option":"option-w1VWmT"};